angular.module('authenticationServices')

    .controller("authenticationServicesListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$state', 'logService',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, $state, logService) {
            $rootScope.title = $filter('translate')('authentication-services.title');

        $rootScope.breadcrumb = [
            { title: $filter('translate')('authentication-services.title') }
            ];

            $scope.allowWrite = LoginService.permissionExist("AUTHENTICATION_SERVICES_WRITE");

        $scope.gridOptionsAuthenticationServices= {
            pdfTitle: "Servicios",
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                { name: 'name', displayName: $filter('translate')('general.name'), enableFiltering: true, enableHiding: false },
                { name: 'description', displayName: $filter('translate')('general.description'), enableFiltering: true, enableHiding: false },
                {
                    name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('general.button_edit'), action: 'ui-sref="authentication_services.edit({id:row.entity.id})"; ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-edit" },
                        { title: $filter('translate')('general.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"',  cssIconClass: "fa fa-remove" }
                    ], { cssClass: "pull-right" })
                },
            ],
            getData: function (options) {
                return Restangular.all('AuthenticationServices').getList(options)
            }
        };


        $scope.goToEdit = function (rowEntity) {
            $state.go("authentication_services.edit", { id: rowEntity.id });
        };


        $scope.deleteDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('events_types.button_delete'),
                message: $filter('translate')('events_types.delete_message') + " " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('AuthenticationServices', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('authentication_services.deleted_success'));
                        $scope.gridOptionsAuthenticationServices.gridApi.core.raise.itemDeleted($scope);

                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });


        }
    }])